import React from 'react';
import { Menu } from 'antd';
import { RouteComponentProps, withRouter, useHistory } from 'react-router-dom';
import { MenuInfo } from 'rc-menu/lib/interface';
import userStore from 'store/user';
import { useObserver } from 'mobx-react';
import accountManageStore from 'store/account-manage';
import { EAuthority } from 'interfaces/account-manage';
import gtm from '@/lib/gtm';
import { useModuleTranslation } from '@/i18n/translation';
type IProps = RouteComponentProps<{ component: string; merchantId: string }>;

const CompanySideMenu = (props: IProps) => {
  const history = useHistory();
  const t = useModuleTranslation('company');

  const {
    match: { params },
  } = props;
  const selectedKeys = params.component ? params.component.split('/') : [];

  const handleCompanyClick = (value: MenuInfo) => {
    // key is merchant id
    const { key } = value;
    gtm.track('ModuleClick', { module: key });
    const to = `/${key}/main/dashboard`;
    if (key === 'dashboard' || key === 'transactions' || key === 'help' || key === 'analytics') {
      history.push(`/main/${key}`);
    } else if (key === 'role' || key === 'user' || key === 'payout' || key === 'balance') {
      const { keyPath } = value;
      const to = `/main/${keyPath.reverse().join('/')}`;
      history.push(to);
    } else {
      const win = window.open(to, '_blank');
      win!.focus();
    }
  };

  const handleBranchClick = (value: MenuInfo) => {
    gtm.track('ModuleClick', { module: value.key });
    const { keyPath } = value;
    const to = `/${userStore.currentMerchantId}/main/${keyPath.reverse().join('/')}`;
    history.push(to);
  };

  return useObserver(() => (
    <Menu
      theme="light"
      selectedKeys={selectedKeys}
      mode="inline"
      onClick={userStore.currentMerchantId ? handleBranchClick : handleCompanyClick}>
      {accountManageStore.authorities.includes(EAuthority.ViewDashboard) && (
        <Menu.Item key={`dashboard`}>
          <span>{t.dashboard}</span>
        </Menu.Item>
      )}
      {accountManageStore.authorities.includes(EAuthority.ViewTransactions) && (
        <Menu.Item key="transactions">
          <span>{t.transactions}</span>
        </Menu.Item>
      )}
      {accountManageStore.authorities.includes(EAuthority.ViewPayment) && (
        <Menu.SubMenu key="payments" title={t.payments}>
          <Menu.Item key="payout">
            <span>{t.payout}</span>
          </Menu.Item>
          <Menu.Item key="balance">
            <span>{t.balance}</span>
          </Menu.Item>
        </Menu.SubMenu>
      )}
      {accountManageStore.authorities.includes(EAuthority.ViewAnalytics) && (
        <Menu.Item key="analytics">
          <span>{t.ana}</span>
        </Menu.Item>
      )}
      {accountManageStore.authorities.includes(EAuthority.ViewUserManagement) && (
        <Menu.SubMenu key="accountManage" title={t.accountMana}>
          <Menu.Item key="role">
            <span>{t.roleMana}</span>
          </Menu.Item>
          <Menu.Item key="user">
            <span>{t.userMana}</span>
          </Menu.Item>
        </Menu.SubMenu>
      )}
      {accountManageStore.authorities.includes(EAuthority.ViewHelp) && (
        <Menu.Item key={`help`}>
          <span>{t.help}</span>
        </Menu.Item>
      )}
    </Menu>
  ));
};

export default withRouter(CompanySideMenu);
